import { Icon } from "@iconify/react";
import pieChart2Fill from "@iconify/icons-eva/pie-chart-2-fill";
import barchartfill from "@iconify/icons-eva/bar-chart-fill";

const getIcon = (name, hFlip) => (
  <Icon
    icon={name}
    width={22}
    height={22}
    hFlip={hFlip}
    className="navbar-icon"
  />
);

const sidebarConfig = [];

sidebarConfig.push(
  {
    title: "dashboard",
    path: "/dashboard",
    icon: getIcon(pieChart2Fill),
  },
  {
    title: "My Calendar",
    path: "/calendar-events",
    icon: getIcon("mdi:calendar"),
  },
  {
    title: "Programmes",
    path: "/list",
    icon: getIcon(barchartfill),
    children: [
      {
        title: "Active Programmes",
        path: "/programmes-folder",
        icon: getIcon(barchartfill),
      },
      {
        title: "Inactive Programmes",
        path: "/inactive-programmes",
        icon: getIcon(barchartfill),
      },
      {
        title: "Coach Programmes Templates",
        path: "/programme_templats",
        icon: getIcon(barchartfill),
      },
    ],
  },
  {
    title: "Members",
    path: "/member",
    icon: getIcon("mdi:person"),
  },
  {
    title: "Chat",
    path: "/chat",
    icon: getIcon("mdi:chat"),
  },
  {
    title: "General Notifications",
    path: "/general-notifications",
    icon: getIcon("mdi:bell-ring-outline"),
  },
  {
    title: "Coach",
    path: "/coach",
    icon: getIcon("mdi:whistle-outline", true),
  },
  {
    title: "Subscription List",
    path: "/subscription-list",
    icon: getIcon("wpf:renew-subscription"),
  },
  {
    title: "Fitness",
    path: "/list",
    icon: getIcon("mdi:gym"),
    children: [
      {
        title: "Exercise library",
        path: "/exercise",
        icon: getIcon("healthicons:exercise-walking"),
      },
      {
        title: "Exercises Type",
        path: "/type-exercise",
        icon: getIcon("healthicons:exercise-walking"),
      },
      {
        title: "Exercises Tags",
        path: "/tages-exercise",
        icon: getIcon("healthicons:exercise-walking"),
      },
      {
        title: "Workout Library",
        path: "/workout_library",
        icon: getIcon("mdi:gym"),
      },
      {
        title: "Workout Type",
        path: "/workout_type",
        icon: getIcon("mdi:gym"),
      },
    ],
  },
  {
    title: "Nutrition",
    path: "/list",
    icon: getIcon("fluent:food-24-filled"),
    children: [
      {
        title: "Daily Meal Plan",
        path: "/nutrition_library",
        icon: getIcon("fluent:food-24-filled"),
      },
      {
        title: "Diet Type",
        path: "/nutrition_type",
        icon: getIcon("fluent:food-24-filled"),
      },
      {
        title: "Food Database",
        path: "/food",
        icon: getIcon("fluent:food-24-filled"),
      },
    ],
  },
  {
    title: "Mindset",
    path: "/list",
    icon: getIcon("flowbite:brain-outline"),
    children: [
      {
        title: "Mindset Library",
        path: "/mindset_library",
        icon: getIcon("flowbite:brain-outline"),
      },
      {
        title: "Mindset Type",
        path: "/mindset_type",
        icon: getIcon("flowbite:brain-outline"),
      },
    ],
  },
  {
    title: "Workbook",
    icon: getIcon("mdi:book-open-page-variant-outline"),
    children: [
      {
        title: "Workbook Library",
        path: "/workbook_library",
        icon: getIcon("mdi:book-open-page-variant-outline"),
      },
    ],
  },
  {
    title: "Trackers",
    icon: getIcon("mdi:clipboard-list-outline"),
    children: [
      {
        title: "Trackers",
        path: "/trackers",
        icon: getIcon("mdi:clipboard-list-outline"),
      },
      {
        title: "Submissions",
        path: "/tracker-submissions",
        icon: getIcon("mdi:inbox-outline"),
      },
      {
        title: "Questions",
        path: "/tracker-questions",
        icon: getIcon("mdi:help-circle-outline"),
      },
      {
        title: "Automations",
        path: "/tracker-automations",
        icon: getIcon("mdi:lightning-bolt-outline"),
      },
    ],
  },
  {
    title: "Videos",
    path: "/list",
    icon: getIcon("octicon:video-24"),
    children: [
      {
        title: "Videos Library",
        path: "/video_library",
        icon: getIcon("octicon:video-24"),
      },
      {
        title: "Videos Type",
        path: "/video_type",
        icon: getIcon("octicon:video-24"),
      },
    ],
  },
  {
    title: "Comments",
    path: "/list",
    icon: getIcon("eva:message-square-fill"),
    children: [
      {
        title: "Comment Library",
        path: "/comment_library",
        icon: getIcon("eva:message-square-fill"),
      },
      {
        title: "Comment Type",
        path: "/comment_type",
        icon: getIcon("eva:message-square-fill"),
      },
    ],
  },
  {
    title: "Community Area",
    path: "/main-community-area",
    icon: getIcon("healthicons:group-discussion-meetingx3"),
    children: [
      {
        title: "General Community Area",
        path: "/community-area",
        icon: getIcon("fluent:people-community-16-filled"),
      },
      {
        title: "Pending Posts",
        path: "/pending-posts",
        icon: getIcon("mdi:account-pending"),
      },
      {
        title: "Rejected Posts",
        path: "/rejected-posts",
        icon: getIcon("mdi:account-cancel"),
      },
      {
        title: "Groups",
        path: "/groups",
        icon: getIcon("fluent:people-community-16-filled"),
      },
    ],
  },
);

sidebarConfig.push({
  title: "Payments",
  path: "/list",
  icon: getIcon("ic:round-date-range"),
  children: [
    {
      title: "Stripe Products",
      path: "/stripe-products",
      icon: getIcon("ic:round-date-range"),
    },
    {
      title: "Transactions",
      path: "/payment-transactions",
      icon: getIcon("ic:round-date-range"),
    },
  ],
});

sidebarConfig.push({
  title: "Support",
  icon: getIcon("ic:round-support-agent"),
  children: [
    {
      title: "Support Tickets",
      path: "/support-ticket",
      icon: getIcon("ic:round-task-alt"),
    },
  ],
});

sidebarConfig.push({
  title: "Client Portal",
  path: "/list",
  icon: getIcon("fluent:settings-20-filled"),
  children: [
    {
      title: "User Form",
      path: "/form-list",
      icon: getIcon("fluent:form-48-filled"),
    },
    {
      title: "User Form Templates",
      path: "/user_form-templates",
      icon: getIcon("fluent:form-48-filled"),
    },
    {
      title: "General Setting",
      path: "/general-setting",
      icon: getIcon("ic:round-date-range"),
    },
    {
      title: "Content Setting",
      path: "/content-setting",
      icon: getIcon("ic:round-date-range"),
    },
  ],
});
sidebarConfig.push({
  title: "General Setting",
  path: "/list",

  icon: getIcon("fluent:settings-20-filled"),
  children: [
    {
      title: "Default Setting",
      path: "default-setting",
      icon: getIcon("ic:round-date-range"),
    },
    {
      title: "Email Setting",
      path: "/email-setting",
      icon: getIcon("ic:round-date-range"),
    },
    {
      title: "Stripe Setting",
      path: "/stripe-setting",
      icon: getIcon("ic:round-date-range"),
    },
    {
      title: "Invoice Setting",
      path: "/invoice-setting",
      icon: getIcon("ic:round-date-range"),
    },
    {
      title: "Email Templates",
      path: "/email-templates",
      icon: getIcon("ic:round-date-range"),
    },
    {
      title: "Calendar Setting",
      path: "/calendar-setting",
      icon: getIcon("ic:round-date-range"),
    },
    {
      title: "Manage Booking Setting",
      path: "/manage-booking-setting",
      icon: getIcon("ic:round-date-range"),
    },
  ],
});
sidebarConfig.push({
  title: "Manage Website",
  path: "/list",

  icon: getIcon("fluent:settings-20-filled"),
  children: [
    {
      title: "Plan Category",
      path: "/plan_category",

      icon: getIcon("iconamoon:category"),
    },
    {
      title: "Pages",
      path: "/website-pages",

      icon: getIcon("ic:round-date-range"),
    },
    {
      title: "Template Pages",
      path: "/template-pages",
      icon: getIcon("ic:round-date-range"),
    },
    {
      title: "Menus",
      path: "/menus",
      icon: getIcon("ic:round-date-range"),
    },
  ],
});
sidebarConfig.push({
  title: "Helping Videos",
  path: "/list",
  icon: getIcon("fluent:video-clip-20-filled"),
  children: [
    {
      title: "Coach Videos",
      path: "/coaches_videos_category",
      icon: getIcon("ic:round-video-library"),
    },
    {
      title: "Member Videos",
      path: "/members_videos_category",
      icon: getIcon("ic:round-video-library"),
    },
  ],
});
sidebarConfig.push({
  title: "Gym TV",
  path: "/WorkoutDisplay",
  icon: getIcon("ic:baseline-tv"),
});
export default sidebarConfig;
